const state = () => ({
  error: false,
  hasPromoCodePopupBeenSeen: false,
  selectedStoreInformation: { store: null, hours: null },
  showPresaleModal: false,
  storeChangeWarningModal: null
});

export default state;
